export default __webpack_public_path__ + "static/media/about-heart.da261d2d.png";